module.exports = __webpack_public_path__ + "9f15ee8b63457b9dadaac8bba4cdb2e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2078_teaser_image.jpg
// module id = 587
// module chunks = 0